<style lang="less">
  // @import '../flow.less';
  @import '../base.less';
</style>

<template>
    <div class="content">
      <div class="main">
          <div>
              <Row>
                  <Col span="24" :md="15">
                      <Row class="title">
                          <h4>项目成员工作流详情</h4>
                      </Row>
                      <div class="info-property">
                          <dl>
                              <dt>项目</dt><dd>{{detail.project}}</dd>
                          </dl>
                          <dl>
                              <dt>申请人</dt><dd>{{detail.user}}</dd>
                          </dl>
                          <dl>
                              <dt>成员类型</dt><dd>{{detail.category}}</dd>
                          </dl>
                          <dl>
                              <dt>状态</dt><dd>{{detail.status_verbose}}</dd>
                          </dl>
                          <dl>
                              <dt>描述</dt><dd>{{detail.description}}</dd>
                          </dl>
                          <dl>
                              <dt>申请时间</dt><dd>{{detail.time_start}}</dd>
                          </dl>
                          <dl>
                              <dt>完成时间</dt><dd>{{detail.time_end ? detail.time_end : '---'}}</dd>
                          </dl>
                          <!-- <dl>
                              <dt>结果</dt><dd>{{ resultElements }}</dd>
                          </dl> -->
                      </div>
                      <Row className="margin-top-10">
                              <Row class="title">
                                  <h4>审批</h4>
                              </Row>
                              <Approves :approves = "detail.approves" approveType = "member" :reFresh= "this.handleReFresh" :status = "detail.status" />
                      </Row>
                   </Col>
                   <Col span="24" :md="{ span: 7, offset: 1 }">
                      <div class="title" >
                          <h4>日志信息</h4>
                      </div>
                      <FlowLogs :logs = "detail.logs" />
                  </Col>
              </Row>
            </div>
      </div>
  </div>
</template>
<script>
import { getMemFlowDetail } from '@/api/memflow'
import Approves from '../base/Approves'
import FlowLogs from '../base/Logs'
export default {
  name: 'SvnFlowDetail',
  components: {
    'Approves': Approves,
    'FlowLogs': FlowLogs
  },
  data () {
    return {
      detail: {},
      changefiles: []
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      this.getMemFlowDetail(this.$route.query.id)
    }
  },
  methods: {
    getMemFlowDetail (id) {
      let params = {
        id: id
      }
      getMemFlowDetail(params).then(res => {
        this.detail = res.data
        this.changefiles = this.detail.files ? this.detail.files.split('\n') : []
      })
    },
    handleReFresh () {
      // 处理刷新操作
      this.getMemFlowDetail(this.$route.query.id)
    }
  },
  mounted: function () {
    this.getMemFlowDetail(this.$route.query.id)
  }
}
</script>
<style lang="less" scoped>
.content .main .info-property dl dt {
    width: 100px;
}
</style>
